import { ageCalculationEPOC } from 'src/services/data';
import { saveAs } from 'file-saver';
import moment from 'moment';

export const getAge = (birthDate) =>
  Math.floor((new Date() - new Date(birthDate).getTime()) / ageCalculationEPOC);

export const mobileNumberFormate = (mobile) => {
  const regex = /(\+91)/g;
  return `${mobile}`.replace(regex, `\$1-`);
};

export const getDataFromLocal = (CACHE_KEY) => {
  const cachedData = localStorage.getItem(CACHE_KEY);

  if (cachedData) {
    const parsedData = JSON.parse(cachedData);

    return parsedData.data;
  } else return false;
};

export const setDataToLocal = (data, CACHE_KEY) => {
  const cachedData = {
    data: data
  };
  localStorage.setItem(CACHE_KEY, JSON.stringify(cachedData));
};

export const maskingGovtID = (input) => {
  if (input == null) return null;
  let str = String(input);

  if (str?.length <= 4) {
    return 'X'.repeat(str?.length);
  }

  const lastFourChars = str?.slice(-4);
  const maskedString = 'X'.repeat(input.length - 4) + lastFourChars;

  return maskedString;
};

export const appointmentType = [
  'appointment_created',
  'pharmacist_joined_call',
  'doctor_joined_call',
  'aiqa_center_joined_call'
];

export function customDebounce(fn, delay) {
  let timeoutId;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

export const statusColor = {
  PENDING: '#F1C40F',
  RAISED: '#E67E22',
  IN_PROGRESS: '#E67E22',
  QUERY: '#F1C40F',
  REJECTED: '#E74C3C',
  APPROVED: '#2ECC71',
  SETTELED: '#3498DB'
};

const convertBase64ToFile = (base64String, fileName, type) => {
  let bstr = atob(base64String);
  let n = bstr.length;
  let uint8Array = new Uint8Array(n);
  while (n--) {
    uint8Array[n] = bstr.charCodeAt(n);
  }
  let file = new File([uint8Array], fileName, { type });
  return file;
};

export const downloadBase64Data = (
  base64String,
  fileName,
  type,
  download = true
) => {
  try {
    let file = convertBase64ToFile(base64String, fileName, type);
    if (download) saveAs(file, fileName);
    return file;
  } catch (e) {}
};

export function filterDaysByDateRange(data, startDate, endDate) {
  const start = moment(startDate);
  const end = moment(endDate);

  const daysInRange = new Set();

  // Collect all days in the date range
  for (let m = moment(start); m.diff(end) <= 0; m.add(1, 'day')) {
    daysInRange.add(m.format('dddd')); // 'dddd' gives full weekday name
  }
  // Filter original data based on matched days
  return data.filter((day) => daysInRange.has(day.title));
}

export function capitalizeEachWord(text) {
  if (!text) return '';
  return text
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
